import React from "react"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { fieldPropTypes } from "redux-form"
import CurrencySelect from "../select/CurrencySelect"
import FieldTextarea from "./FieldTextarea"

const useFieldStyle = makeStyles((theme) => ({
  field: {
    maxWidth: "inherit",
    width: 150,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2)
  }
}))

const DEFAULT_CURRENCY = "USD" // $USD by default

/**
 *
 * This component is used by Redux Form to hold user's input for a Form Element of type Currency
 * The value stored in Redux for the Form is an object of model
 * {
 *   amount: the current amount, Double, required,
 *   currency: the current currency, String, required (will be of type "USD", "EUR", etc.)
 * }
 * */
const FieldCurrency = (props) => {
  const { input, defaultCurrency } = props
  const { value, onChange, onBlur } = input
  const classes = useFieldStyle()

  // This is what redux-form will hold
  const computeCurrencyValue = (amount, currency) => ({
    amount: parseFloat(amount),
    currency
  })

  if (!value.currency) {
    onChange(computeCurrencyValue(value.amount, DEFAULT_CURRENCY))
  }

  return (
    <Box display="flex">
      <FieldTextarea
        {...props}
        placeholder={value.amount || 0}
        input={{
          value: value.amount
        }}
        onChange={(e) =>
          onChange(computeCurrencyValue(e.target.value, value.currency))
        }
        onBlur={(e) =>
          onBlur(computeCurrencyValue(e.target.value, value.currency))
        }
      />
      <CurrencySelect
        onChange={(newCurrency) =>
          onChange(computeCurrencyValue(value.amount, newCurrency))
        }
        className={classes.field}
        defaultValue={value.currency || defaultCurrency}
      />
    </Box>
  )
}

FieldCurrency.propTypes = {
  ...fieldPropTypes,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool
}

FieldCurrency.defaultProps = {
  placeholder: "",
  readonly: false
}

export default FieldCurrency
